var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_373_2110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.0813 0.5H6.15942V1.56875H7.15317V0.5H8.2313V3.73438H7.15317V2.65625H6.1688V3.73438H5.0813M9.6563 1.57812H8.70474V0.5H11.6907V1.57812H10.7344V3.73438H9.6563M12.1641 0.5H13.2938L13.9875 1.63906L14.6813 0.5H15.811V3.73438H14.7329V2.13125L13.9782 3.29375L13.2235 2.13125V3.73438H12.1641M16.3454 0.5H17.4235V2.66563H18.9516V3.73438H16.3454",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0437 22.5781L3.49683 5.21558H20.5031L18.9562 22.5687L11.9859 24.5",
    fill: "#E44D26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23.0234V6.64062H18.9516L17.625 21.4531",
    fill: "#F16529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65625 8.76416H12V10.8923H8.99063L9.1875 13.072H12V15.1954H7.2375M7.33125 16.2642H9.46875L9.61875 17.9657L12 18.6032V20.8251L7.63125 19.6063",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3251 8.76416H11.9907V10.8923H17.1282M16.936 13.072H11.9907V15.2001H14.6157L14.3673 17.9657L11.9907 18.6032V20.8157L16.3501 19.6063",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_2110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/HTML5.9d095204272c1fcf64b2fd16c069b215.svg";
export { ForwardRef as ReactComponent };